import React, { useState } from 'react';
import Carousel from '../../Component/Home/Carousel/Carousel';
import SideBar from '../../Component/Shared/SideBar/SideBar';
import { useLoaderData } from 'react-router-dom';
import './homepage.css';
const HomePage = () => {
    const loadedInfo = useLoaderData();
    const [HomePageMassage, setHomePageMassage] = useState(loadedInfo.data[0]);
    
    return (
        <div className='my-5 bcolor'>
            <div>
                <Carousel />
            </div>
            <div className='container my-5'>
                <div className='row'>
                    <div className='col-lg-10 col-xl-9 content-area'> 
                        {HomePageMassage ? (
                            <div className='article-content'>
                                {HomePageMassage.content}
                            </div>
                        ) : (
                            <div className='text-center py-5'>
                                <h2>Content Coming Soon</h2>
                                <p className='text-muted'>Please check back later</p>
                            </div>
                        )}
                    </div>
                    <div className='col-lg-2 col-xl-3'>
                        <SideBar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomePage;